<script>
	import UserAccess from '../components/UserAccess/UserAccessTable.svelte';
	import { currentUser } from '../utils/stores.js';
</script>

{#if $currentUser.hasAdminPermissions}
	<UserAccess />
{/if}
